<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" icon><v-icon>mdi-account-outline</v-icon></v-btn>
    </template>
    <v-list>
      <v-list-item>
        <v-list-item-title class="text-overline">{{ userName }}</v-list-item-title>
      </v-list-item>
      <v-divider/>
      <v-list-item @click="handleLogoutClick">
        <v-list-item-icon class="mr-2">
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="text-subtitle-2">{{ $t('common.logout') }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { authContext } from '@/plugins/msalPlugin'
export default {
  computed: {
    userName () {
      return authContext?.account?.name || ''
    }
  },
  methods: {
    async handleLogoutClick () {
      await this.$msal.signOut()
    }
  }
}
</script>
